import { RunnerStatusMarketDetails } from '@ps/isp-web-services-types';
import type { Selection } from '@ps/web-sports-types';

import {
  type Entity,
  sportsCompetition,
  sportsEvent,
  sportsMarket,
  sportsSelection,
  sportsSport
} from '../entities';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { getIsOddsBoostMarket } from './utils/getIsOddsBoostMarket';
import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

export const selectionAdded = (
  context: TrackingContextValue,
  {
    eventId,
    eventTypeId,
    competitionId,
    startTime,
    marketId,
    selectionId,
    odds,
    runnerStatus,
    marketType
  }: Selection
) => {
  const entities: Entity[] = [
    sportsEvent({ eventId, eventStartTime: new Date(startTime).getTime() }),
    sportsMarket({
      marketId,
      marketInPlay: false,
      marketIsOddsBoost: getIsOddsBoostMarket(marketType)
    }),
    sportsSelection({
      selectionId,
      selectionOdds: odds?.decimalDisplayOdds?.decimalOdds,
      selectionStatus: runnerStatus || RunnerStatusMarketDetails.ACTIVE,
      isStartingPrice: !odds?.decimalDisplayOdds?.decimalOdds
    }),
    sportsSport({ sportId: eventTypeId })
  ];

  if (competitionId) {
    entities.push(sportsCompetition({ competitionId }));
  }

  context = mergeWithTrackingContextValue(context, entities);

  GAEvent({ action: 'Add Selection' }, context);
  buttonClick({ buttonName: 'Add Selection' }, context);
};
